/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Single-series standing-check-records-per-day trend (035 US3), on the shared
 * au-panel design system (mirrors WorkoutTrendChart). Coral line, text-labelled
 * legend, point tooltip (exact date + count), graceful single-day/empty handling.
 *
 * Props: { data } — [{ date:'YYYY-MM-DD', records:int }] ascending
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const StandingCheckTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;
  const single = Array.isArray(data) && data.length === 1;

  return (
    <div className="au-panel" data-testid="sc-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Standing checks per day</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Standing check records</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value) => [Number(value).toLocaleString(), 'Standing check records']}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="records" name="Standing check records" stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="sc-trend-empty">
          {single
            ? `Single day: ${shortDate(data[0].date)} — ${Number(data[0].records).toLocaleString()} standing check record(s).`
            : 'Not enough data to plot a trend (need at least 2 days).'}
        </div>
      )}
    </div>
  );
};

export default StandingCheckTrendChart;
